const navlinks = [
  { id: '9c4e306a14764a0c99e306e5f82ee6bc', name: 'home', displayName: 'Home', route: '/' },
  { id: 'f0704fc5e5604861a04c4be30eb0490b', name: 'about', displayName: 'About', route: '/about' }
]

export { navlinks }